var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRobotFilled = function SvgRobotFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1a1 1 0 0 1 1 1v2h4c2.757 0 5 2.243 5 5v1h.5c.827 0 1.5.673 1.5 1.5v3c0 .827-.673 1.5-1.5 1.5H22v1c0 2.757-2.243 5-5 5H7c-2.757 0-5-2.243-5-5v-1h-.5C.673 16 0 15.327 0 14.5v-3c0-.827.673-1.5 1.5-1.5H2V9c0-2.757 2.243-5 5-5h4V2a1 1 0 0 1 1-1M6 16a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm5 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm6 0a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM7.5 9a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 7.5 9m9 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 16.5 9",
    clipRule: "evenodd"
  })));
};
export default SvgRobotFilled;